import { Appointment } from '../types';
import { INITIAL_APPOINTMENTS, AVAILABLE_SLOTS } from '../constants';

// Simulated in-memory database
let appointments: Appointment[] = [...INITIAL_APPOINTMENTS];

export const getAppointments = (): Appointment[] => {
  return [...appointments];
};

export const checkAvailability = (date: string): string[] => {
  const dayAppointments = appointments.filter(a => a.date === date && a.status !== 'Cancelled');
  const bookedTimes = dayAppointments.map(a => a.time);
  return AVAILABLE_SLOTS.filter(slot => !bookedTimes.includes(slot));
};

export const bookAppointment = (date: string, time: string, patientName: string, type: string, phone: string): Appointment | null => {
  const available = checkAvailability(date).includes(time);
  if (!available) return null;

  const validTypes: Appointment['type'][] = ['Checkup', 'Cleaning', 'Emergency', 'Consultation'];
  const appointmentType = validTypes.includes(type as Appointment['type']) ? (type as Appointment['type']) : 'Consultation';

  const newAppt: Appointment = {
    id: Math.random().toString(36).substr(2, 9),
    date,
    time,
    patientName,
    type: appointmentType,
    status: 'Confirmed',
    phone
  };
  appointments.push(newAppt);
  return newAppt;
};

export const cancelAppointment = (date: string, time: string): boolean => {
  const index = appointments.findIndex(a => a.date === date && a.time === time && a.status !== 'Cancelled');
  if (index === -1) return false;
  
  appointments[index].status = 'Cancelled';
  return true;
};

export const rescheduleAppointment = (oldDate: string, oldTime: string, newDate: string, newTime: string): boolean => {
  const index = appointments.findIndex(a => a.date === oldDate && a.time === oldTime && a.status !== 'Cancelled');
  if (index === -1) return false;

  const available = checkAvailability(newDate).includes(newTime);
  if (!available) return false;

  appointments[index].date = newDate;
  appointments[index].time = newTime;
  return true;
};
